import { useQuery } from '@apollo/client';
import { REWARDED_DRIVERS } from '..';

export const useGetRewardedDriversQuery = () => {
    const { data, previousData, ...rest } = useQuery(REWARDED_DRIVERS);

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getRewardedDrivers,
        data: data?.CITRIN_MGT_getRewardedDrivers ?? [],
    };
};
